import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { take } from 'rxjs/operators';
import * as moment from 'moment';
import { AttendanceAdministrationService } from '../../../admin360/attendance-administration/attendance-administration.service';
import { AbsentNotice } from '../../../admin360/attendance-administration/review-absent-notices/absent-notice.model';
import { ReviewAbsentNoticesService } from '../../../admin360/attendance-administration/review-absent-notices/review-absent-notices.service';
import { AddAttachmentDialogComponent } from '../../../shared-components/add-attachment-dialog/add-attachment-dialog.component';
import { TylerMatTableDataSource } from '../../../shared-components/angular-material/extended.class';
import { ErrorList } from '../../../shared-components/controls/error-prompt/error-list.model';
import { Attachment } from '../../../shared-components/models/attachment.model';
import { System } from '../../../shared-components/System';
import { YearService } from '../../../shared-components/year/year.service';
import { StudentSummaryService } from '../student-summary.service';
import { StudentService } from '../../../shared-components/student/student.service';

@Component({
    selector: 'app-absent-notice-submission-modal',
    templateUrl: './absent-notice-submission-modal.component.html',
    styleUrls: ['./absent-notice-submission-modal.component.css']
})
export class AbsentNoticeSubmissionModalComponent implements OnInit {
    absentNotice: AbsentNotice;
    columnsToDisplay = ['FileName', 'Description', 'DocumentType', 'UploadedDate', 'Actions'];
    angularMatData = new TylerMatTableDataSource();
    @ViewChild('startDateInput', { read: ElementRef, static: true }) startDateRef: ElementRef;
    @ViewChild('endDateInput', { read: ElementRef, static: true }) endDateRef: ElementRef;

    errors: ErrorList[] = [];

    constructor(private dialogRef: MatDialogRef<AbsentNoticeSubmissionModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private dialog: MatDialog,
        private absentNoticesService: ReviewAbsentNoticesService,
        private studentService: StudentService,
        private attendanceAdminService: AttendanceAdministrationService) { }

    ngOnInit() {
        this.absentNotice = this.data.absentNotice;
        // Guarantees the dates will actually be a Date type  (Javascript...)
        this.absentNotice.StartDate = new Date(this.absentNotice.StartDate);
        this.absentNotice.EndDate = new Date(this.absentNotice.EndDate);
        this.loadAttachmentTable();
    }

    cancelClick() {
        this.dialogRef.close();
    }

    deleteAttachmentClick(attachmentId: number) {
        this.absentNotice.Attachments.find(o => o.Id == attachmentId).Deleted = true;
        this.loadAttachmentTable();
    }

    saveAttachment(attachment: Attachment) {
        // PRE: an attachment to open
        // POST: takes you to the student attachment page
        if (attachment.FileName && !attachment.AttachmentFileName) {
            attachment.AttachmentFileName = attachment.FileName;
        }

        if (attachment.MyFileBase64String && attachment.AttachmentFileName && attachment.FileType) {
            System.viewFileFromBase(attachment.MyFileBase64String, attachment.FileType, attachment.AttachmentFileName);
        } else if (attachment.Id && attachment.AttachmentFileName) {
            System.viewFileFromId(attachment.Id, attachment.AttachmentFileName);
        }
    }

    addAttachmentClick() {
        // POST: opens a modal to add an attachment

        // Initializing attachment
        const attachment = new Attachment();
        attachment.Id = this.absentNotice != undefined ? -(this.absentNotice.Attachments.length + 1) : -1;
        attachment.DocumentId = 0;
        attachment.FileName = '';
        attachment.Description = '';
        attachment.UploadedDate = new Date();
        attachment.MyFileBase64String = '';
        attachment.FileType = '';
        attachment.Comment = '';
        attachment.ViewFileOnWebsite = true;
        attachment.AttachmentDescription = '';

        // Opening modal
        const dialogBox = this.dialog.open<AddAttachmentDialogComponent>(AddAttachmentDialogComponent, {
            data: {
                attachment: attachment,
                newAttachment: true,
                requireDocumentType: true
            },
            disableClose: true
        });
        dialogBox.afterClosed().subscribe(() => {
            if (dialogBox.componentInstance.saved) {
                attachment.AttachmentDescription = attachment.Description;
                attachment.DocumentBase64 = attachment.MyFileBase64String;
                attachment.DocumentType = attachment.FileType;
                attachment.MyFileBase64String = '';
                this.absentNotice.Attachments.push(attachment);
                this.loadAttachmentTable();
            }
        });
    }

    loadAttachmentTable() {
        this.angularMatData.data = this.absentNotice.Attachments.filter(x => x.Deleted == false);
    }

    saveClick() {
        this.validateCheck(() => {
            if (this.errors.length == 0) {
                this.absentNoticesService.saveAbsentNotice(this.absentNotice).subscribe(result => {
                    if (result) {
                        this.dialogRef.close();
                    }
                });
            }
        });
    }

    validateCheck(_callBack) {
        this.errors = [];

        if (this.absentNotice.StartDate == null || !moment(this.absentNotice.StartDate).isValid()) {
            this.errors.push(
                {
                    fieldName: '',
                    fieldRef: this.startDateRef,
                    errorMsg: 'You must specify a Start Date'
                });
        }

        if (this.absentNotice.EndDate == null || !moment(this.absentNotice.EndDate).isValid()) {
            this.errors.push(
                {
                    fieldName: '',
                    fieldRef: this.endDateRef,
                    errorMsg: 'You must specify a End Date'
                });
        }

        if (this.errors.length == 0) {
            this.attendanceAdminService.getSchoolDaysBetweenDates(this.studentService.studentEnrollment.SiteYearId, this.absentNotice.StartDate.toLocaleDateString(), this.absentNotice.EndDate.toLocaleDateString()).pipe(take(1)).subscribe(dates => {
                if (dates.length > 5) {
                    this.errors.push(
                        {
                            fieldName: '',
                            fieldRef: this.endDateRef,
                            errorMsg: 'An Absent Request cannot be more than 5 school days.  Please contact your school for absences longer than this period.'
                        });
                }
                _callBack();
            });
        }
        else {
            _callBack();
        }
    }
}
